export * from './ModuleSlider';
